import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginOptions from '../views/LoginOptions'
import LoginOptionsStep2 from '../views/LoginOptionsStep2'
import MobileForm from '../components/MobileForm'
import CredentialsForm from '../components/CredentialsForm'
import OtpForm from '../components/OtpForm'
import SilentRegistrationForm from '../components/SilentRegistrationForm'
import store from '../store/store'



Vue.use(VueRouter)



const routes = [
    {
        name: "LoginOptions",
        path: '/',
        component: LoginOptions,
        children: [
            {
                name: "MobileForm",
                path: 'msisdn',
                component: MobileForm,
            },
            { 
                name: "CredentialsForm",
                path: 'credentials',
                component: CredentialsForm
            }
        ]
    },
    {
        name: "loginOptionStep2",
        path: '/step2',
        component: LoginOptionsStep2,
        children: [
            {
                name: "OtpForm",
                path: 'otp',
                component: OtpForm
            },
            {
                name: "SilentRegistrationForm",
                path: 'silent-registration',
                component: SilentRegistrationForm
            }
        ]
    }
    
]



const router = new VueRouter({
  routes,
})


router.beforeEach((to, from, next) => {
  
    let isNavigationGuardEnabled = false;

    if (to.path == "/") {
        isNavigationGuardEnabled = true;

        store.dispatch('resetState');
        next({name: "MobileForm"});
    }


    /* Check forward steps */
    if (to.name == "loginOptionStep2") {

        isNavigationGuardEnabled = true;

        if (store.state.step1Visited) {

            if (store.state.isSilentRegistration) {
                next({name: 'SilentRegistrationForm'});
            } else {
                next({name: 'OtpForm'});
            }

        } else {
            next({path: from.path});
        }
        
    }


    /* Check backward steps */
    if ((to.name == "LoginOptions" || to.name == "MobileForm" || to.name == "CredentialsForm" ) &&
        (from.name == "loginOptionStep2" || from.name == "OtpForm" || from.name == "SilentRegistrationForm") && store.state.step1Visited) {

        isNavigationGuardEnabled = true;

        store.dispatch('resetState');
        next({name: "MobileForm"});

    }


  
  if (!isNavigationGuardEnabled) {
      next();
  }
    
  
})

export default router